import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {catchError, map, Observable} from 'rxjs';
import {GridGetService, GridServiceParams, GridServiceResponse} from 'src/app/shared/model/page-grid';
import {removeEmptyParams} from 'src/infrastructure/helper/remove-empty-params';
import { ExportPdfService } from 'src/app/shared/service/files/export-pdf.service';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class VendorStatementGridService implements GridGetService<any> {
  private readonly baseUrl = 'dbov2/vendor-statements';
  private readonly http = inject(HttpClient);
  private readonly pdfService = inject(ExportPdfService);

  getItems({filters, page, sort} : GridServiceParams): Observable<GridServiceResponse<any>>  {
    const params:Record<string, string | number | boolean> = {
      pageSize:  page?.pageSize || 25,
      pageNumber : (page?.pageIndex || 0) + 1,
      propertyName: sort?.active || '',
      orderKey: sort?.direction || '',

      vendorId: filters?.['vendorId'] ?? '',
      asOfDate: filters?.['asOfDate'] ? moment(filters?.['asOfDate']).format('YYYY-MM-DD') : '',
    };

    removeEmptyParams(params);

    return this.http.get<GridServiceResponse<any>>(`${this.baseUrl}`, { params: {...params} })
    .pipe(catchError((error:HttpErrorResponse)=>{
        throw new Error(error?.message || 'Server error');
    }));
  }

  getPdf({filters, page, sort}: GridServiceParams): Observable<void> {
    const params:Record<string, string | number | boolean> = {
      exportToPdf: true,
      format: 'pdf',
      pageSize:  page?.pageSize || 25,
      pageNumber : (page?.pageIndex || 0) + 1,
      propertyName: sort?.active || '',
      orderKey: sort?.direction || '',

      vendorId: filters?.['vendorId'] ?? '',
      asOfDate: filters?.['asOfDate'] ? moment(filters?.['asOfDate']).format('YYYY-MM-DD') : '',
    };

    removeEmptyParams(params);

    return this.http.get<{ pdfBase64: string }>(`${this.baseUrl}`, {params: { ...params }})
    .pipe(
      map(response => {
        if (response && response.pdfBase64) {
          this.pdfService.savePdfFromBase64(response.pdfBase64, 'vendor-statement.pdf');
          return;
        } else {
          throw new Error('Invalid PDF response from server');
        }
      }),
      catchError((error: HttpErrorResponse) => {
        console.error('PDF download error:', error);
        throw new Error(error?.message || 'PDF generation failed');
      })
    );
  }
}
